<template>
  <div class="login_con" style="min-height: 220px;">
    <div style="position: absolute; right: -20px; color: white; font-size: 16px;" v-if="modal">X</div>
    <div class="l_tit">重置密码</div>
    <div class="reg_con">
      <p><input name="" type="text"  class="w365 put_txt input_three" id="registerThree" placeholder="输入密码" /></p>
      <i style="display:none;" class="spa8">请输入新密码</i>
      <p class="wrap w264 mt30">
        <input name="" type="button" class="login_btn login_b input_two" value="确认" id="sub3" />
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['modal']
}
</script>
<style scoped>
  @import '../common/loginNreg/login.css';
</style>



// WEBPACK FOOTER //
// src/components/common/find-pwd/reset.vue